import { useEffect, useState } from 'react'
import { getSalesTeam } from '@user/store/salesTeam/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'

export const useGetSalesTeamOnMount = (id: number) => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )
  useEffect(() => {
    let mounted = true
    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(
          getSalesTeam({ id: id, includeUsers: true }),
        )

        if (mounted) {
          if (getSalesTeam.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error getting sales team users`)
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, id])

  return status
}
